import { scrollReviewSectionIntoView } from "@inductiveautomation/ws-components";
import { ReviewSection } from "../../../Training.types";
import { PurchaseTestForm } from "../schema";

const sectionForData = (
  data: Partial<PurchaseTestForm>
): ReviewSection | undefined => {
  if (data.contact) {
    return "contact";
  } else if (data.creditCard) {
    return "payment";
  } else if (data.billingAddress) {
    return "billing_address";
  }
};

export const scrollBasedOnNextData = (data: Partial<PurchaseTestForm>) => {
  const section = sectionForData(data);
  if (!section) return;

  scrollReviewSectionIntoView(`#${section}`, {
    behavior: { initial: "smooth" },
  });
};
